export const LOGO_URL= "/images/logo.svg";
export const LOGO_WHITE_URL = "/images/logo-white.svg";
export const CORPORATE_URL = "/images/market-pay-logo.svg";